import styled from 'styled-components';

export const TemplateBasedContainer = styled.div.attrs({
  id: 'TemplateBasedContainer',
})``;

export const TemplateBasedField = styled.div.attrs({})`
  min-width: 200px;
  width: 93%;
`;
export const TemplateBasedFieldHeader = styled.h4.attrs({
  id: 'TemplateBasedFieldHeader',
})`
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-size: 0.9rem;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeSpeed;
  margin-bottom: 8px;
  @media (max-width: 599px) {
  }
  @media (min-width: 600px) and (max-width: 959px) {
  }
  @media (min-width: 900px) and (max-width: 1279px) {
  }
  @media (min-width: 1280px) {
  }
`;

export const RequiredField = styled.span.attrs({})`
  color: red;
`;

export const TemplateBasedTextAreaField = styled.textarea.attrs({
  id: 'TemplateBasedTextAreaField',
})`
  height: 100px;
  margin-top: 5px;
  margin-bottom: 10px;
  width: 100%;
  @media (max-width: 599px) {
  }
  @media (min-width: 600px) and (max-width: 959px) {
  }
  @media (min-width: 900px) and (max-width: 1279px) {
  }
  @media (min-width: 1280px) {
  }
`;
export const TwoColumnContainerTop = styled.div.attrs({})`
  display: grid;
  margin-top: 20px;
  @media (max-width: 570px) {
    grid-template-columns: 100%;
  }
  @media (min-width: 571px) and (max-width: 699px) {
    grid-template-columns: 50% 50%;
    grid-template-rows: 1fr;
  }
  @media (min-width: 700px) and (max-width: 1279px) {
    grid-template-columns: 50% 50%;
    grid-template-rows: 1fr;
  }
  @media (min-width: 1280px) {
    grid-template-columns: 50% 50%;
    grid-template-rows: 1fr;
  }
`;
export const TwoColumnContainer = styled.div.attrs({})`
  display: grid;
  margin-bottom: 30px;
  @media (max-width: 470px) {
    grid-template-columns: 100%;
  }
  @media (min-width: 571px) and (max-width: 699px) {
    grid-template-columns: 50% 50%;
    grid-template-rows: 1fr;
  }
  @media (min-width: 700px) and (max-width: 1279px) {
    grid-template-columns: 50% 50%;
    grid-template-rows: 1fr;
  }
  @media (min-width: 1280px) {
    grid-template-columns: 50% 50%;
    grid-template-rows: 1fr;
  }
`;
export const TemplateBasedTextInputField = styled.input.attrs({
  type: 'text',
})`
  height: 30px;
  width: 100%;
  padding-right: 0px;
  @media (max-width: 599px) {
  }
  @media (min-width: 600px) and (max-width: 959px) {
  }
  @media (min-width: 900px) and (max-width: 1279px) {
  }
  @media (min-width: 1280px) {
  }
`;

export const TemplateBasedTextAreaInputField = styled.input.attrs({
  type: 'textArea',
})`
  height: 30px;
  width: 100%;
  padding-right: 0px;
  @media (max-width: 599px) {
  }
  @media (min-width: 600px) and (max-width: 959px) {
  }
  @media (min-width: 900px) and (max-width: 1279px) {
  }
  @media (min-width: 1280px) {
  }
`;
export const TemplateBasedNumericInputField = styled.input.attrs({
  type: 'number',
})`
  height: 30px;
  width: 100%;
  padding-right: 0px;
  @media (max-width: 599px) {
  }
  @media (min-width: 600px) and (max-width: 959px) {
  }
  @media (min-width: 900px) and (max-width: 1279px) {
  }
  @media (min-width: 1280px) {
  }
`;
export const TemplateBasedButtonsContainer = styled.div.attrs({
  id: 'TemplateBasedButtonsContainer',
})`
  text-align: right;
  margin-right: 2%;
  margin-top: 2%;
  @media (max-width: 384px) {
    text-align: center;
  }
`;
export const TemplateBasedButton = styled.button.attrs({})`
  margin-left: 10px;
  padding: 10px 20px;
  background-color: ${props => props.theme.primaryColor};
  color: white;
  :disabled {
    background-color: gray;
  }
  @media (max-width: 385px) {
    margin-bottom: 16px;
  }
`;
